module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"events-log":"Журнал событий"},"en":{"events-log":"Events log"}}')
  delete Component.options._Ctor
}
